<template>
    <framed-layout>

        <template #center>
            <h3 class="font-bold">Keeldu projektist</h3>
        </template>

        <template #right>
            <a @click="$router.go(-1)" class="btn-circle cursor-pointer">
                <i class="text-xl text-blue-500 pi pi-times"></i>
            </a>
        </template>

        <div class="max-w-lg mx-auto text-center">
            <icon name="help" width="119" height="119" vbWidth="119" vbHeight="119" stroke="none" class="my-8 md:my-12" />

            <h3 class="mb-5 text-2xl font-semibold">Oled kindel, et soovid projektist loobuda?</h3>

            <p>Projektist loobumisel ei ole võimalik hiljem liituda.</p>

            <button
                @click="decline"
                ref="declineButton"
                class="w-full sm:w-72 mt-12 text-white bg-orange-400 btn xs:w-64 md:mt-20"
            >Kinnitan
            </button>
        </div>
    </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import {decline} from "@/store/project.api";

export default {
    props: ['projectUserId'],
    components: {
        FramedLayout
    },
    data() {
        return {
            //
        }
    },
    methods: {
        async decline() {
            this.$refs.declineButton.classList.add('p-disabled');
            await decline(this.$route.params.projectUserId).then(({data}) => {
                this.$refs.declineButton.classList.remove('p-disabled');
                setTimeout(() => {
                    this.processAxiosPositiveResponse(data);
                }, 100);
            },() => {
                this.$refs.declineButton.classList.remove('p-disabled');
            });
            this.$router.push('/projects');
        }
    }
}
</script>
